'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';

const propertyFilter = property => property.formField && property.fieldType === 'text';

const hubSpotFieldTransform = property => ({
  key: property.name,
  label: property.label,
  format: 'TEXT',
  networkDefault: false
});

const PropertiesReducer = (state = ImmutableMap(), action) => {
  switch (action.type) {
    case Actions.HS_PROPERTIES_FETCH_SUCCEEDED:
      {
        if (!action.payload) {
          return state;
        }

        return state.withMutations(newState => {
          action.payload.results.forEach(category => {
            category.properties.filter(propertyFilter).forEach(property => {
              newState.set(property.name, hubSpotFieldTransform(property));
            });
          });
        });
      }

    default:
      {
        return state;
      }
  }
};

export default PropertiesReducer;